document.addEventListener('DOMContentLoaded',()=>{
  const nav=document.querySelector('.cel-nav');
  if(nav){
    const groups=[...nav.querySelectorAll(':scope > details')];
    groups.forEach(d=>{
      let closeTimer;
      d.addEventListener('mouseenter',()=>{clearTimeout(closeTimer);groups.forEach(o=>{if(o!==d)o.removeAttribute('open')});d.setAttribute('open','')});
      d.addEventListener('mouseleave',()=>{closeTimer=setTimeout(()=>d.removeAttribute('open'),120)});
      d.querySelector('summary')?.addEventListener('click',e=>{groups.forEach(o=>{if(o!==d)o.removeAttribute('open')})});
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape')groups.forEach(d=>d.removeAttribute('open'))});
  }
});


// Keep the Celestial header search copy clean and emoji-free, including after app injections.
(()=>{
  const cleanPlaceholder='Suche nach Produkten, Marken, TCGs, Spielen, Figuren …';
  const clean=()=>document.querySelectorAll('.cel-header input[type="search"]').forEach(input=>{
    if(input.getAttribute('placeholder')!==cleanPlaceholder) input.setAttribute('placeholder',cleanPlaceholder);
  });
  clean();
  const header=document.querySelector('.cel-header');
  if(header){
    new MutationObserver(clean).observe(header,{subtree:true,childList:true,attributes:true,attributeFilter:['placeholder']});
  }
})();
